import { render } from "./SearchTerms.vue?vue&type=template&id=1bfce1d0&scoped=true"
import script from "./SearchTerms.vue?vue&type=script&lang=js"
export * from "./SearchTerms.vue?vue&type=script&lang=js"

import "./SearchTerms.vue?vue&type=style&index=0&id=1bfce1d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfce1d0"]])

export default __exports__